// * Import 3rd party
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(
  TextField,
  {}
)(({ theme, customProps }) => ({
  height: "2em !important",
  width: "100%",
  "&.MuiFormControl-root": {
    backgroundColor: theme.palette.form.fieldBackground,
  },
  "& .MuiInputBase-root": {
    height: "2em !important",
  },
  "& .MuiInputBase-input": {
    fontSize: theme.size[14],
    color: theme.palette.form.text,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent !important",
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.form.text,
    fontSize: theme.size[13],
  },
}));

export default StyledTextField;
